<!-- main.component.html -->
<p-toast position="bottom-right" key="confirm"></p-toast>

<div class="layout-wrapper" [ngClass]="{'layout-sidebar-active': sidebarVisible}">

  <!-- TOPBAR -->
  <div class="layout-topbar">
    <div class="topbar-left">
      <a class="menu-button cursor-pointer" (click)="toggleSidebar()">
        <i class="pi pi-bars text-2xl"></i>
      </a>
    </div>

    <div class="topbar-right flex align-items-center gap-3">
      <button pButton class="p-button-rounded p-button-text p-button-plain"
              [icon]="isDarkMode ? 'pi pi-sun' : 'pi pi-moon'"
              [disabled]="true"
              (click)="toggleTheme()">
      </button>

      <div class="relative cursor-pointer" (click)="showDialog()">
        <i class="pi pi-bell text-xl p-2 border-circle hover:surface-100 transition-colors"
           pBadge
           [value]="numeroTareas.toString()"
           severity="danger"></i>
      </div>

      <div class="user-profile flex align-items-center gap-2 cursor-pointer hover:surface-100 p-2 border-round transition-colors"
           (click)="menu.toggle($event)">
        <div class="text-right hidden md:block line-height-2">
          <span class="font-bold text-sm block">{{user.name}}</span>
          <span class="text-xs text-500 block">Usuario</span>
        </div>
        <p-avatar image="/assets/images/usuario.png" shape="circle"></p-avatar>
      </div>

      <p-menu #menu [popup]="true" [appendTo]="'body'"
              [model]="[{label: 'Salir', icon: 'pi pi-power-off', command: salir.bind(this)}]"></p-menu>
    </div>
  </div>

  <!-- SIDEBAR -->
  <div class="layout-sidebar">
    <a class="sidebar-logo" [routerLink]="['/']">
      <img [src]="logoSrc" alt="Logo" />
    </a>
    <div class="sidebar-scroll-content">

      <!-- TARJETA PARA QUE SE VEA  -->
      <div class="sidebar-card">
        <ul class="layout-menu">
          <li class="menu-separator">MENÚ PRINCIPAL</li>

          <li *ngFor="let item of menuItems" class="layout-root-menuitem">

            <!-- ROOT CON HIJOS -->
            <a *ngIf="item.items?.length"
               (click)="toggleGroup(item)"
               class="layout-menuitem-root cursor-pointer p-ripple"
               pRipple
               [ngClass]="{'active-root': item.expanded}">
              <div class="flex align-items-center gap-2">
                <i [class]="'pi pi-' + (item.icon || 'folder')"></i>
                <span class="layout-menuitem-text">{{item.label}}</span>
              </div>

              <i class="pi pi-chevron-down layout-menuitem-toggler"
                 [ngClass]="{'rotated': item.expanded}"></i>
            </a>

            <!-- SUBMENU: SOLO SI HAY HIJOS -->
            <ul *ngIf="item.items?.length"
                class="layout-submenu"
                [@submenu]="item.expanded ? 'visible' : 'hidden'">
              <li *ngFor="let sub of item.items">
                <a (click)="navigate(sub)"
                   class="layout-menuitem-link cursor-pointer p-ripple"
                   pRipple
                   routerLinkActive="active-route">
                  <i [class]="sub.icon" class="layout-menuitem-icon"></i>
                  <span class="layout-menuitem-text">{{sub.label}}</span>
                </a>
              </li>
            </ul>

            <!-- ROOT SIN HIJOS -->
            <a *ngIf="!item.items?.length"
               (click)="navigate(item)"
               class="layout-menuitem-root cursor-pointer p-ripple"
               pRipple
               routerLinkActive="active-route">
              <div class="flex align-items-center gap-2">
                <i [class]="'pi pi-' + (item.icon || 'folder')"></i>
                <span class="layout-menuitem-text">{{item.label}}</span>
              </div>
            </a>

          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- MAIN -->
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>

    <div class="layout-footer">
      <div class="footer-left">
        <img [src]="logoSrc" height="15" class="mr-2 opacity-60">
      </div>
      <span class="footer-right text-sm text-500 font-medium">Happy Mile - 2026</span>
    </div>
  </div>

  <!-- MASK MOVIL -->
  <div class="layout-mask" *ngIf="sidebarVisible" (click)="sidebarVisible = false"></div>
</div>

<!-- DIALOG NOTIFICACIONES -->
<p-dialog header="Notificaciones"
          [(visible)]="displayDialog"
          [modal]="true"
          [style]="{width: '400px'}"
          [draggable]="false"
          [resizable]="false">
  <div class="flex flex-column gap-3 pt-2">
    <div *ngIf="objetonuevo.length === 0" class="text-center text-500">Sin notificaciones.</div>

    <div class="surface-card p-3 shadow-1 border-round border-left-3 border-blue-500"
         *ngFor="let msg of objetonuevo">
      <span class="text-xs font-bold text-blue-600 block mb-1">TAREA</span>
      <span class="font-medium text-sm text-900 block">{{msg.title}}</span>
      <span class="text-xs text-500 block text-right mt-1">{{msg.campoAgregado}}</span>
    </div>
  </div>
</p-dialog>
